import React from 'react'
import Start from '../../common/pages/Start.jsx'

const S2_Start = (props) => {
    return (
        <Start data={props}/>
    )
}

export default S2_Start

